import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "../Styles/User_destination.css";
import api from "../Api.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ImageLightbox from "../Components/Helping Component/ImageZoom.jsx";

function User_Destinations() {
  const [popularDestination, setPopularDestination] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);

  const settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ],
  };

  useEffect(() => {
    const getDestinations = async () => {
      try {
        const response = await api.get("/destinations");
        if (response.data.status) {
          setPopularDestination(response.data.data);
        }
      } catch (error) {
        console.log("API Error:", error);
      }
    };

    getDestinations();
  }, []);

  const handleOpenGallery = async(item) => {
    const response = await api.get(`/destinations/${item.id}`);

    const images = [item.cover_photo, ...(response.data.data.photos || [])];
    setCurrentImages(images);
    setLightboxOpen(true);
  };

  return (
    <div className='user_destinations'>
      <h1 className='destination_headline'>Popular Destinations</h1>

      <div className="slider-container">
        <Slider {...settings}>
          {popularDestination?.map((item) => (
            <div className='overlay' key={item.id}>
              <div className="slider-item">
                <img 
                  src={item.cover_photo}
                  alt={item.name}
                  onClick={() => handleOpenGallery(item)}
                  style={{ cursor: "pointer" }}
                />
                <h3>{item.name}</h3>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />
    </div>
  );
}

export default User_Destinations;
